import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeTab: 'Prompts',
  activeSubTab: 'Specialties',
};

const superadminSlice = createSlice({
  name: 'superadminSlice',
  initialState,
  reducers: {
    setActiveTabSlice: (state, { payload }) => {
      state.activeTab = payload;
    },
    setActiveSubTabSlice: (state, { payload }) => {
      state.activeSubTab = payload;
    },
  },
});

const { actions, reducer } = superadminSlice;

export const { setActiveTabSlice, setActiveSubTabSlice } = actions;

export default reducer;
